import React from "react";
import PropTypes from "prop-types";
import LazyImage from "../LazyImage/LazyImage";

const CardLongImageContainer = ({
  imageSrc,
  altTitle = "",
  className = "",
  type = "default",
  aspectRatio = "16/9"
}) => {
  const containerStyle = {
    width: "100%",
    position: "relative",
    maxHeight: "351px",
    marginBottom: "16px"
  };

  return (
    <div className={`card__image--container ${className}`} style={containerStyle}>
      <LazyImage
        src={imageSrc}
        alt={altTitle}
        width="100%"
        aspectRatio={aspectRatio}
        style={{
          borderRadius: "8px"
        }}
        shimmerProps={{
          style: {
            borderRadius: "8px"
          }
        }}
      />
    </div>
  );
};

CardLongImageContainer.propTypes = {
  className: PropTypes.string,
  imageSrc: PropTypes.string,
  altTitle: PropTypes.string,
  type: PropTypes.string,
  aspectRatio: PropTypes.string
};

export default CardLongImageContainer;
